import * as FacilitiesActions from './../actions/facilities_actions';
import extend from 'lodash/extend';
import * as UserActions from './../actions/user_actions';

export var Facilites = (state = {
    FaciliteDetails: null,
    FaciliteCreateDeatils: null,
    FaciliteUpdateDeatils: null,
    FaciliteDetailsByID: null,
    FaciliteAdmin: null,
    FaciliteAdminUser: null,
    ActivateAdmin: null,
    DeactivateAdmin: null,
    DeactiveFacility: null,
    FacilityImageUpload: null,
    FacilitiesListViewType: 'grid-view',
    ResendLinkStatus : null,
}, action) => {
    switch (action.type) {
        // case "@@redux/INIT": {
        // }
        case 'persist/REHYDRATE': {
            if (action.payload.Facilites) {

                return extend({}, state, action.payload.Facilites);
            } else {
                return state;
            }
        }

        case FacilitiesActions.RESEND_EXPIRED_LINK: {

            return extend({}, state, { ResendLinkStatus: action.data });
        }
        case FacilitiesActions.GET_ALL_FACILITY: {

            return extend({}, state, { FaciliteDetails: action.data });
        }
        case FacilitiesActions.CREATE_FACILITY: {

            return extend({}, state, { FaciliteCreateDeatils: action.data });
        }
        case FacilitiesActions.UPDATE_FACILITY: {

            return extend({}, state, { FaciliteUpdateDeatils: action.data });
        }
        case FacilitiesActions.GET_FACILITY_BY_ID: {

            return extend({}, state, { FaciliteDetailsByID: action.data });
        }
        case FacilitiesActions.ADD_FACILITY_ADMIN: {

            return extend({}, state, { FaciliteAdmin: action.data });
        }
        case FacilitiesActions.GET_ADMIN_USER_BY_ID: {

            return extend({}, state, { FaciliteAdminUser: action.data });
        }
        case FacilitiesActions.ACTIVATE_FACILITY_ADMIN: {

            return extend({}, state, { ActivateAdmin: action.data });
        }
        case FacilitiesActions.DEACTIVATE_FACILITY_ADMIN: {

            return extend({}, state, { DeactivateAdmin: action.data });
        }
        case FacilitiesActions.DEACTIVATE_FACILITY: {

            return extend({}, state, { DeactiveFacility: action.data });
        }

        case FacilitiesActions.FACILITY_IMAGE_UPLOAD: {
            return extend({}, state, { FacilityImageUpload: action.data });
        }

        case FacilitiesActions.FACILITIES_LISTVIEW_TYPE: {
            return extend({}, state, { FacilitiesListViewType: action.data });
        }


        case UserActions.USER_LOG_OUT: {

            return extend({}, state, {
                FaciliteDetails: null,
                FaciliteCreateDeatils: null,
                FaciliteUpdateDeatils: null,
                FaciliteDetailsByID: null,
                FaciliteAdmin: null,
                FaciliteAdminUser: null,
                ActivateAdmin: null,
                DeactivateAdmin: null,
                DeactiveFacility: null,
                FacilityImageUpload: null,
                FacilitiesListViewType: 'grid-view',ResendLinkStatus:null
            })
        }
            break; default:
            return state;
    }
};



/** WEBPACK FOOTER **
 ** ./src/reducers/facilites_reduser.js
 **/